import Image, { ImageProps } from "next/image";
import { shimmer, toBase64 } from "./simmer";

interface ShimmerImageProps extends Omit<ImageProps, "placeholder"> {
  shimmerWidth?: number;
  shimmerHeight?: number;
  width?: number;
  height?: number;
}

const ShimmerImage: React.FC<ShimmerImageProps> = ({
  width,
  height,
  shimmerWidth,
  shimmerHeight,
  ...imageProps
}) => {
  // Use provided shimmer dimensions or fall back to image dimensions
  const shimmerW = shimmerWidth || (typeof width === "number" ? width : 400);
  const shimmerH = shimmerHeight || (typeof height === "number" ? height : 300);

  return (
    <Image
      {...imageProps}
      width={width}
      height={height}
      placeholder={`data:image/svg+xml;base64,${toBase64(shimmer(shimmerW, shimmerH))}`}
    />
  );
};

export default ShimmerImage;
